/**
 * Dựng tham số tra cứu khách hàng GetFly cho hai tab của trang chủ.
 *
 * Tách ra khỏi trang vì trước đây đoạn này nằm trong cả `HomePage.jsx` lẫn
 * `HomePageV2.jsx` — hai bản sao của cùng một con bug, và sửa một bên thì bên
 * kia vẫn hỏng.
 *
 * ── Sự cố 03/10/2026 ──
 * Tab "Lịch giảng" gửi `account_type: "19,14,13,12,11"`. Đo thẳng lên GetFly:
 *
 *   account_type: 19                 ->  5 bản ghi   (chạy)
 *   account_type: "19"               ->  5 bản ghi
 *   account_type: "19,14,13,12,11"   ->  0 bản ghi, HTTP 200   <-- hỏng IM LẶNG
 *   account_type: [19,14,13,12,11]   ->  HTTP 400
 *
 * GetFly chỉ nhận MỘT giá trị cho `account_type`. Chuỗi phẩy không nổ, nó trả
 * rỗng kèm mã 200 — nên màn hình hiện "không có kết quả" mà log thì sạch bong.
 * Cùng một giới hạn với việc tra CCCD: GetFly không có lọc nhiều giá trị.
 *
 * ── Và bộ lọc đó chưa từng đúng ──
 * Lọc `account_type: 19` trả về các dòng có `relation_id: 23`. `account_type`
 * KHÔNG phải `relation_id`, nên nó chưa bao giờ lọc đúng nhóm mà người viết
 * nghĩ — kể cả khi chỉ gửi một giá trị. Vì vậy cách sửa không phải là gọi 5
 * lần rồi gộp, mà là **bỏ hẳn bộ lọc cho tab lịch giảng** (anh Trung chốt).
 * Tab này bắt buộc nhập tên mới tra, nên tìm theo tên là đủ.
 *
 * Tab "Điều kiện" giữ nguyên: nó gửi ĐÚNG MỘT giá trị và đang chạy.
 */

/**
 * @param {'schedule'|'condition'} tab
 * @param {Object} p
 * @param {string} p.name          tên/biển số khách gõ vào
 * @param {number|string} [p.courseId]      id option khoá học (số, không phải nhãn)
 * @param {number|string} [p.optionIdHang]  account_type của hạng — CHỈ dùng cho tab điều kiện
 * @returns {Object} tham số cho `integrationApi.queryCustomers`
 */
export function dungTruyVanKhachHang(tab, p = {}) {
  const { name, courseId, optionIdHang } = p || {};
  const q = { account_name: String(name == null ? '' : name).trim() };

  // `khoa_hoc` lưu ID OPTION dạng SỐ chứ không phải nhãn: lọc bằng 'BTĐ-K36'
  // trả 0 bản ghi, phải dùng 710. Đo trên GetFly 27/09/2026.
  const khoa = Number(courseId);
  if (courseId !== undefined && courseId !== null && courseId !== '' && Number.isFinite(khoa)) {
    q.khoa_hoc = khoa;
  }

  // Lịch giảng: KHÔNG lọc nhóm. Xem đầu file.
  if (tab === 'schedule') return q;

  // Điều kiện: đúng một giá trị, và chỉ khi xác định được hạng.
  if (optionIdHang !== undefined && optionIdHang !== null && optionIdHang !== '') {
    q.account_type = optionIdHang;
  }
  return q;
}

export default dungTruyVanKhachHang;
